import { InputLabel, Typography } from '@mui/material';

import { ATSConnectHiringRequestCreateFeedbackTestIds } from 'data-testids/ATS';
import { CandidateFeedbackModalTypes } from 'features/Connect/features/ConnectATSIntegration/enums';
import { CreateForm } from './CreateForm';
import {
  SelectContainer,
  TemplateSelectionFormContainer,
} from '../../../../styles/scorecardStyles';
import { TemplateSelectionFormProps } from '../../../../types/scorecardTypes';

export const TemplateSelectionForm: React.FC<TemplateSelectionFormProps> = ({
  candidateName,
  modalType,
  roleId,
}) => {
  const labelText =
    modalType === CandidateFeedbackModalTypes.SCORECARD
      ? 'Scorecard template'
      : 'Reference template';
  const titleText =
    modalType === CandidateFeedbackModalTypes.SCORECARD
      ? `New scorecard for ${candidateName}`
      : `New reference for ${candidateName}`;

  return (
    <TemplateSelectionFormContainer>
      <Typography
        variant="h2"
        data-testid={ATSConnectHiringRequestCreateFeedbackTestIds.CREATE_PANE_TITLE}
      >
        {titleText}
      </Typography>
      <SelectContainer>
        <InputLabel
          data-testid={ATSConnectHiringRequestCreateFeedbackTestIds.CREATE_PANE_LABEL_TEXT}
          sx={{ marginBottom: 1 }}
        >
          {labelText}
        </InputLabel>
        <CreateForm roleId={roleId} />
      </SelectContainer>
    </TemplateSelectionFormContainer>
  );
};
